import { repiAddSubjectFields } from '../../../store/repiStore';
import { string as YupString, object as YupObject } from '../../common/Yup';

export function addSubjectSchema(translate, subjectType) {
    const wrongInputMsg = translate("Search.Common.Validation.WrongInput");
    const maxLengthMsg = translate("Repi.Error.Validation.MaxLength");

    if (subjectType === 1) {
        return YupObject().shape({
            [repiAddSubjectFields.contributorSubjectId]: YupString().required(wrongInputMsg).max(20, maxLengthMsg.replace("${length}", 20)),
            [repiAddSubjectFields.country]: YupString().required(wrongInputMsg),
            [repiAddSubjectFields.name]: YupString().required(wrongInputMsg).max(100, maxLengthMsg.replace("${length}", 100)),
            [repiAddSubjectFields.surname]: YupString().required(wrongInputMsg).max(100, maxLengthMsg.replace("${length}", 100)),
            [repiAddSubjectFields.pin]: YupString().max(25, maxLengthMsg.replace("${length}", 25))
        });
    }

    if (subjectType === 2) {
        return YupObject().shape({
            [repiAddSubjectFields.contributorSubjectId]: YupString().required(wrongInputMsg).max(20, maxLengthMsg.replace("${length}", 20)),
            [repiAddSubjectFields.country]: YupString().required(wrongInputMsg),
            [repiAddSubjectFields.companyId]: YupString().required(wrongInputMsg).required(wrongInputMsg).max(25, maxLengthMsg.replace("${length}", 25)),
            [repiAddSubjectFields.companyName]: YupString().max(300, maxLengthMsg.replace("${length}", 300)),
            [repiAddSubjectFields.name]: YupString().max(100, maxLengthMsg.replace("${length}", 100)),
            [repiAddSubjectFields.surname]: YupString().max(100, maxLengthMsg.replace("${length}", 100)),
        });
    }

    if (subjectType === 3) {
        return YupObject().shape({
            [repiAddSubjectFields.contributorSubjectId]: YupString().required(wrongInputMsg).max(20, maxLengthMsg.replace("${length}", 20)),
            [repiAddSubjectFields.country]: YupString().required(wrongInputMsg),
            [repiAddSubjectFields.companyId]: YupString().required(wrongInputMsg).max(25, maxLengthMsg.replace("${length}", 25)),
            [repiAddSubjectFields.companyName]: YupString().max(300, maxLengthMsg.replace("${length}", 300))
        });
    }

    return YupObject().shape({});
}